import React, { useState, useEffect } from 'react'
import { Modal } from 'reactstrap'
import SiteDropdown from '../../../Templates/SiteDropdown/SiteDropdown'
import SurveyDropdown from '../../../Templates/SurveyDropdown/SurveyDropdown'
import AffiliateSearch from '../../../../../components/AffiliateSearch/AffiliateSearch'

export default function PropertySetOverrideModal({ propertyId, modalOpen, setModalOpen, refresh, setRefresh, showSystemMessage, propertyName }) {
    const [overrideSiteId, setOverrideSiteId] = useState(0)
    const [overrideSurveyId, setOverrideSurveyId] = useState(0)
    const [affiliateId, setAffiliateId] = useState(0)
    const [overrideSiteName, setOverrideSiteName] = useState('')
    const [overrideSurveyName, setOverrideSurveyName] = useState('')
    const [affiliateName, setAffiliateName] = useState('')
    const [submitting, setSubmitting] = useState(false)
    const [affiliate, setAffiliate] = useState(null)
    const [survey, setSurvey] = useState()
    const [site, setSite] = useState()

    useEffect(() => {
        setAffiliateId(affiliate ? affiliate.id : null)
        setAffiliateName(affiliate ? affiliate.name : '')
    }, [affiliate])

    useEffect(() => {
        setOverrideSiteId(site ? site.id : null)
        setOverrideSiteName(site ? site.name : '')
    }, [site])

    useEffect(() => {
        setOverrideSurveyId(survey ? survey.id : null)
        setOverrideSurveyName(survey ? survey.name : '')
    }, [survey])

    const saveOverride = () => {
        setSubmitting(true)

        const authtoken = localStorage.getItem('adm-auth-token')
        

        fetch(`${process.env.REACT_APP_API_URL}/avatar/property/${propertyId}/overrides`, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'x-app-token': authtoken,
            },
            body: JSON.stringify({
                affiliate_id: affiliateId,
                affiliate_name: affiliateName,
                override_site_id: overrideSiteId,
                override_site_name: overrideSiteName,
                override_survey_id: overrideSurveyId,
                override_survey_name: overrideSurveyName,
                property_name: propertyName,
            }),
        })
            .then((res) => res.json())
            .then((result) => {
                if (result['success'] === true) {
                    showSystemMessage('success', 'Override Saved')
                    setSubmitting(false)
                    setRefresh(!refresh)
                    setModalOpen(false)
                } else if (result['success'] === false) {
                    setSubmitting(false)
                    showSystemMessage('error', result.errors.message)
                } else {
                    setSubmitting(false)
                    showSystemMessage('error', 'Error fetching site data.')
                }
            })
            .catch((error) => {
                console.log('Error on Avatar Site/Set Overrides: ', error.message)
                setSubmitting(false)
                showSystemMessage('error', 'Connection error.')
            })
    }

    return (
        <Modal isOpen={modalOpen} toggle={() => setModalOpen(false)} className="modal-sm">
            <div className="card">
                <div className="card-header d-flex justify-content-between align-items-center">
                    <h1 className="mb-h1-dark">Add Override</h1>
                    <button type="button" className="close" onClick={() => setModalOpen(false)}>
                        <span aria-hidden="true">x</span>
                    </button>
                </div>
                <div className="card-body">
                    <label htmlFor="site-dropdown">Affiliate ID:</label>
                    {/* <input type="text" className="form-control mb-2" onChange={(e) => setAffiliateId(e.target.value)}></input> */}
                    <AffiliateSearch affiliate={affiliate} setAffiliate={setAffiliate} order={3} />
                    <label htmlFor="site-dropdown">Site:</label>
                    <SiteDropdown site={site} setSite={setSite} order={2} />

                    <label htmlFor="site-dropdown" className="mt-2">
                        Survey:
                    </label>
                    <SurveyDropdown survey={survey} setSurvey={setSurvey} order={1} />
                    <div className="text-right mt-3">
                        {submitting ? (
                            <button className="btn btn-primary btn-sm" disabled>
                                Save
                            </button>
                        ) : (
                            <button className="btn btn-primary btn-sm" onClick={saveOverride}>
                                Save
                            </button>
                        )}
                    </div>
                </div>
            </div>
        </Modal>
    )
}
